import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { IRootState } from "reducer";

const StyledTopPanel = styled.div<{ isSidebarOpen: boolean, isFullScreenMode: boolean, height?: number }>`
    display: flex;
    align-items: center;
    width: 100%;
    height: ${({ height, theme }) => height ?? theme.layout.navTopPanelHeight}px;
    padding-left: ${({isSidebarOpen, isFullScreenMode, theme}) => isFullScreenMode ? '10px' : isSidebarOpen ? `${theme.layout.sidebarWidth + 31}px` : "31px"};
    background: #F4F4F4;
`;

const TopPanel: React.FC<ReduxProps & { height?: number }> = ({children, isSidebarOpen, isFullScreenMode, height}) => <StyledTopPanel
  height={height}
  isSidebarOpen={isSidebarOpen}
  isFullScreenMode={isFullScreenMode}
>
  {children}
</StyledTopPanel>;

type ReduxProps = {
  isSidebarOpen: boolean;
  isFullScreenMode: boolean;
}

const mapStateToProps = ({app}: IRootState): ReduxProps => ({
  isSidebarOpen: app.isSideBarOpen,
  isFullScreenMode: app.fullscreen,
});

export default connect(mapStateToProps)(TopPanel);